import { usePostHog as usePH } from 'posthog-js/react';
import posthog from 'posthog-js';
import { useCallback } from 'react';

const usePostHogTracking = () => {
  const posthogReact = usePH();

  const trackEvent = useCallback(
    (eventName: string, properties?: Record<string, unknown>) => {
      if (typeof window !== 'undefined' && posthogReact) {
        posthogReact.capture(eventName, properties);
      }
    },
    [posthogReact]
  );

  const trackPageView = useCallback(
    (pageName?: string) => {
      if (typeof window !== 'undefined' && posthogReact) {
        posthogReact.capture('$pageview', { page: pageName });
      }
    },
    [posthogReact]
  );

  const identifyUser = useCallback(
    (userId: string, properties?: Record<string, unknown>) => {
      if (typeof window !== 'undefined' && posthogReact) {
        posthogReact.identify(userId, properties);
      }
    },
    [posthogReact]
  );

  const resetUser = useCallback(() => {
    if (typeof window !== 'undefined' && posthogReact) {
      posthogReact.reset();
    }
  }, [posthogReact]);

  return {
    sdk: posthogReact,
    trackEvent,
    trackPageView,
    identifyUser,
    resetUser,
  };
};

export { posthog };

export default usePostHogTracking;
